module.exports = __webpack_public_path__ + "icofont.50a4ab76e700a83e649b";


//////////////////
// WEBPACK FOOTER
// /home/arsalan/Desktop/Dev Stack/Otacon (npm start)/src/assets/icofont/fonts/icofont.woff2
// module id = ../../../../../src/assets/icofont/fonts/icofont.woff2
// module chunks = main